// Local translations
export const T = {
  en_GB: {
    showChart: "Show chart",
    showTable: "Show table",
    showPortfolioName: "Show portfolio name",
    atLeastOneOption: "At least one display option must be selected",
  },
  nb_NO: {
    showChart: "Vis diagram",
    showTable: "Vis tabell",
    showPortfolioName: "Vis porteføljenavn",
    atLeastOneOption: "Minst ett visningsalternativ må være valgt",
  },
} as const;
